export default __webpack_public_path__ + "static/marketing-0368984d9afe87a2de305b1cecf4a6ee.webp";